/*
 * @Author: dali crayoncrook@gmail.com
 * @Date: 2026-01-19 16:51:23
 * @LastEditors: dali crayoncrook@gmail.com
 * @LastEditTime: 2026-01-19 18:16:03
 * @FilePath: \gerlun-react-website\src\modules\tax.js
 */
import { API_LIST } from '@/const/api'
import BaseModule from './baseModule'
import { doEncrypt } from '../utils/crypto-sm2'

class Tax extends BaseModule {
  /**
   * 校验法人身份
   */
  checkLegalPersonIdentity(query) {
    return this.get({
      url: API_LIST.CHECK_LEGAL_PERSON_IDENTITY,
      query
    })
  }

  /**
   * 简化版登录（支持验证码）
   */
  loginSimpleWithCode(query) {
    const data = {
      ...query,
      encryptFlg: true,
      taxUserPwd: doEncrypt(query.taxUserPwd)
    }
    return this.post({
      url: API_LIST.LOGIN_SIMPLE_WITH_CODE,
      data: data
    })
  }
}

export default new Tax()
